import { useRef } from 'react';

import Image from 'next/image';

import { Row } from '@components/formStyles';
import Typography from '@components/Typography';
import CustomIcon from '@components/utils/CustomIcon';
import { CloseIcon, PlayVideoModalIcon } from '@assets/icons';
import ImageWithFallback from '@components/utils/ImageWithFallback';
import { useDevice } from '@contexts/device';
import VideoPlayer from '@components/ui/video-player';
import { useSkipEffectOnMount } from '@hooks/lifecycle';

import { ModalWrapper, VideoWrapper, Wrapper } from './styled';

type Props = {
  visible: boolean;
  toggleModal: () => void;
  title: string;
  videoURL?: string;
  isVideo?: boolean;
  fallBackImage?: string;
};

const VideoModal = ({
  title,
  videoURL,
  visible,
  toggleModal,
  fallBackImage,
}: Props) => {
  const { isDesktop } = useDevice();
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useSkipEffectOnMount(() => {
    const body = document.querySelector('body');
    if (body) {
      body.style.overflow = 'hidden';
      return () => {
        body.style.overflow = 'initial';
      };
    }
  }, []);
  return (
    <ModalWrapper visible={visible} onClick={toggleModal}>
      <Wrapper ref={wrapperRef} onClick={(e) => e.stopPropagation()}>
        <Row
          justifyContent='space-between'
          alignItems={isDesktop ? 'center' : 'flex-start'}
          style={{ height: '24px' }}
        >
          <Typography variant='Title4' color='D500' weight='SemiBold'>
            {title}
          </Typography>

          <CustomIcon
            icon={CloseIcon}
            fontSize={24}
            paletteColor='D500'
            clickable
            onClick={toggleModal}
          />
        </Row>

        <VideoWrapper>
          <VideoPlayer
            tour={true}
            url={videoURL}
            PlayIcon={
              <CustomIcon icon={PlayVideoModalIcon} width={83} height={66} />
            }
            FallbackComponent={
              <div>
                {isDesktop ? (
                  <ImageWithFallback
                    Component={Image}
                    src={fallBackImage ?? ''}
                    alt={title || 'Setur Görseli Hazırlanmakta'}
                    fallbackImage='/static/images/setur-static.jpg'
                    width={860}
                    height={453}
                    style={{ objectFit: 'contain' }}
                  />
                ) : (
                  <ImageWithFallback
                    Component={Image}
                    src={fallBackImage ?? ''}
                    alt={title || 'Setur Görseli Hazırlanmakta'}
                    fallbackImage='/static/images/setur-static.jpg'
                    fill
                    style={{ objectFit: 'contain' }}
                  />
                )}
              </div>
            }
          />
        </VideoWrapper>
      </Wrapper>
    </ModalWrapper>
  );
};

export default VideoModal;
